<template>
  <div>
    <base-nav v-model="showMenu" class="navbar-absolute top-navbar" type="" :transparent="true">
      <div slot="brand" class="navbar-wrapper">
        <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
        <div class="navbar-toggle d-inline" :class="{ toggled: $sidebar.showSidebar }">
          <button type="button" class="navbar-toggler" @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="navbar-brand " href="#pablo">{{ routeName }}</a>
      </div>

      <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
        <base-dropdown tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" class="nav-item" title-classes="nav-link"
          menu-classes="dropdown-navbar">
          <template slot="title">

            <div class="d-lg-none  pt-2 pb-2">
              <router-link to="/user/profile-setup" class="nav-item dropdown-item "
                v-if="this.$global.menuUserType != 'sales'"><i class="far fa-bell pr-2"></i>Your Profile</router-link>
            </div>

            <div class="d-lg-none pt-2 pb-2" v-if="this.$global.creditcardsetup">
              <router-link to="/user/card-setting" class="nav-item dropdown-item "><i
                  class="far fa-credit-card pr-2"></i>Card Setting</router-link>
            </div>
            <div class="d-lg-none pt-2 pb-2" v-if="this.$global.questionnairesetup && false">
              <router-link to="/user/questionnaire" class="nav-item dropdown-item "><i
                  class="far fa-credit-card pr-2"></i>Questionnaire</router-link>
            </div>
            <div class="d-lg-none  pt-2 pb-2" v-if="this.$store.getters.userData.user_type === 'client'">
              <router-link to="/integrations" class="nav-item dropdown-item"><i
                  class="far fa-bell pr-2"></i>Integrations</router-link>
            </div>
            <div class="d-lg-none pt-2 pb-2">
              <a href="#" @click="popResetPassword" class="nav-item dropdown-item">Change Password</a>
            </div>
            <hr class="d-lg-none" />
            <div class="photo"><img id="topnavphoto" :src="this.$global.globalProfilePhoto" /></div>
            <b class="caret d-none d-lg-block d-xl-block"></b>
            <p class="d-lg-none pl-2" v-on:click.stop.prevent="logout">Log out</p>
          </template>

          <li class="nav-link d-none d-lg-block d-xl-block">
            <router-link to="/user/profile-setup" class="nav-item dropdown-item"
              v-if="this.$global.menuUserType != 'sales'">Profile</router-link>
          </li>
          <li class="nav-link d-none d-lg-block d-xl-block" v-if="this.$global.creditcardsetup">
            <router-link to="/user/card-setting" class="nav-item dropdown-item">Card Setting</router-link>
          </li>
          <li class="nav-link d-none d-lg-block d-xl-block" v-if="this.$global.questionnairesetup && false">
            <router-link to="/user/questionnaire" class="nav-item dropdown-item">Questionnaire</router-link>
          </li>
          <li class="nav-link d-none d-lg-block d-xl-block" v-if="this.$store.getters.userData.user_type === 'client'">
            <router-link to="/integrations" class="nav-item dropdown-item ">Integrations</router-link>
          </li>
          <li class="nav-link d-none d-lg-block d-xl-block">
            <a href="#" @click="popResetPassword" class="nav-item dropdown-item">Change Password</a>
          </li>
          <div class="dropdown-divider  d-none d-lg-block d-xl-block"></div>
          <li class="nav-link">
            <a href="#" class="nav-item dropdown-item" v-on:click.stop.prevent="logout">Log out</a>
          </li>
        </base-dropdown>
      </ul>
    </base-nav>
    <!-- Modal Update Password -->
    <modal id="modalUpdatePassword" :show.sync="modals.updatepassword" headerClasses="justify-content-center"
      modalContentClasses="modal-updatepassword">
      <h4 slot="header" class="title title-up">Change Password</h4>
      <div class="text-center">
        <img src="/img/reset-password.png" />
      </div>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form ref="frmresetlogin" @submit.prevent="handleSubmit(ProcessResetPassword)">

          <ValidationProvider name="new password" rules="required|confirmed:confirmation"
            v-slot="{ passed, failed, errors }">
            <base-input id="newpwd" v-model="password" type="password" label="New Password" autocomplete="chrome-off"
              :error="errors[0]" :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
            </base-input>
          </ValidationProvider>

          <ValidationProvider name="Confirm New Password" vid="confirmation" rules="required"
            v-slot="{ passed, failed, errors }">
            <base-input id="confpass" v-model="confirmation" type="password" label="Confirm New Password"
              autocomplete="chrome-off" :error="errors[0]" :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
            </base-input>
          </ValidationProvider>
          <hr />
          <ValidationProvider name="current password" rules="required" v-slot="{ passed, failed, errors }">
            <base-input id="currpassword" v-model="currpassword" type="password" label="Your current password"
              autocomplete="chrome-off" :error="errors[0]" :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
            </base-input>
          </ValidationProvider>

          <div class="container text-center pt-4">
            <button :disabled="isSubmittingResetPassword" type="submit" class="btn">{{ btnResetPasswordText }}</button>
          </div>
          <small v-if="errorupdatepassword"><span style="color:#ec250d">* Sorry, your current password
              invalid</span></small>
        </form>
      </ValidationObserver>
      <template slot="footer">

      </template>
    </modal>
    <!-- Modal Update Password -->
  </div>
</template>
<script>
//import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import SidebarToggleButton from './SidebarToggleButton';
import { extend } from "vee-validate";
import { required, confirmed, min } from "vee-validate/dist/rules";
import swal from 'sweetalert2';

extend("required", required);
extend("confirmed", confirmed);
extend("min", min);

export default {
  components: {
    SidebarToggleButton,
    //CollapseTransition,
    BaseNav,
    Modal
  },
  computed: {
    routeName() {
      var { name } = this.$route;
      if (this.$route.matched.length > 1) {
        name = '';
        for (let i = 0; i < this.$route.matched.length; i++) {
          if (i == (this.$route.matched.length - 1)) {
            if (this.$route.matched[i].name != 'index') {
              name = name + this.$route.matched[i].name;
            }
          } else {
            if (this.$route.matched[i + 1].name == 'index') {
              name = name + this.$route.matched[i].name;
            } else {
              name = name + this.$route.matched[i].name + ' > ';
            }
          }

        }
      }
      //const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      modals: {
        updatepassword: false,
      },
      password: "",
      currpassword: "",
      confirmation: "",
      btnResetPasswordText: "Change Password",
      isSubmittingResetPassword: false,
      errorupdatepassword: false,
    };
  },
  methods: {
    popupdatepasswordsuccess() {
      swal.fire({
        title: 'Change Password',
        text: 'your password has been updated!',
        timer: 2000,
        showConfirmButton: false,
        icon: 'success'
      });
    },
    ProcessResetPassword() {
      this.btnResetPasswordText = 'Change new password...';
      this.isSubmittingResetPassword = true;

      var userdata = this.$store.getters.userData

      this.$store.dispatch('updatePass', {
        usrID: userdata.id,
        newpassword: this.password,
        currpassword: this.currpassword,
      })
        .then(response => {
          if (response.result == 'success') {
            this.modals.updatepassword = false;
            this.popupdatepasswordsuccess();
          } else {
            this.btnResetPasswordText = "Reset Password";
            this.isSubmittingResetPassword = false;
            this.errorupdatepassword = true;
          }

        }, error => {
          this.btnResetPasswordText = "Reset Password";
          this.isSubmittingResetPassword = false;
          this.errorupdatepassword = true;

        })

    },
    popResetPassword() {

      this.password = "";
      this.confirmation = "";
      this.btnResetPasswordText = "Change Password";
      this.isSubmittingResetPassword = false;
      this.errorupdatepassword = false;
      this.modals.updatepassword = true;
    },
    logout() {
      localStorage.removeItem('companyGroupSelected');
      this.$global.selectsGroupCompany.companyGroupList = null;
      this.$store.dispatch('destroyToken')
        .then(response => {
          //this.$router.push({ name: 'Login' })
          window.document.location = '/login';
        })
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },

  },
  mounted() {
    /*var userdata = this.$store.getters.userData
    if (userdata.customer_card_id != '') {
      this.$global.creditcardsetup = true;
    }else{
      this.$global.creditcardsetup = false;
    }*/
  }
};
</script>
<style>
.top-navbar {
  top: 0px;
}
.modal-content .form-group:not(.has-danger) input{
  border: 1px solid #cad1d7 !important;
}
.modal .modal-body .form-group input{
  color:#222a42;
}

.modal-updatepassword {
  max-width: 520px;
  margin: 0 auto;
}
</style>
